export const WELLNESS_OPIONS = [
    "Acupuncturist", "Chiropractor", "Esthetician", "Medical Doctor/D.O.", "Naturopath", "Nurse/Nurse Practitioner", "Nutritionist", "Health Coach", "Fitness Instructor",
    "Mental Health Therapist", "Massage Therapist", "Pain Specialist", "Pharmacist", "Physical Therapist", "Ph.D.", "Wellness Influencer", "Other"
];
export const SHARE_PLAN_SNiP = [
    "Share SNiP with friends and family", "Promote SNiP on social media", "Share with clients in a coaching or consulting business", "Include in my blog, podcast, or email newsletter",
    "Add to an existing wellness business or product line", "Make passive income through health-focused affiliate marketing", "Build a personalized wellness business with SNiP",
    "Other – I have a unique approach!"
];

export const SOCIAL_PLATFORMS = [
    "Instagram", "Facebook", "LinkedIn", "YouTube", "Google", "Word of mouth", "Affiliate", "Wellness provider", "Event (please specify below)", "Other (please specify below)"
];
export const SERVICE_OFFER = [
    "Online / Virtual only", "In-office / In-person only", "Both online and in-person", "Other – please specify"
];

export const RETAIL_BUSINESS = [
    "Brick-and-mortar retail store", "Online wellness store", "Gym or fitness studio", "Spa or wellness center", "Health food store or co-op", "Boutique or specialty shop",
    "Other – Please specify in the box below"
];

export const EMPLOYEES_NUMBER = [
    "1–10 employees", "11–50 employees", "51–200 employees", "201–500 employees", "501–1,000 employees", "1,000+ employees"
]

export const PERSONALIZED_ICONS = [
    { icon: "non_gmo_icon.png", text: "Non GMO" },
    { icon: "daily_free.png", text: "Dairy Free" },
    { icon: "soy_free.png", text: "Soy Free" },
    { icon: "gluten_free_icon.png", text: "Gluten Free" },
    { icon: "nut_free_icon.png", text: "Nut Free" }
]